import { Plus, Trash2 } from 'lucide-react'

// Editor genérico de LISTA de objetos (JSONB). Serve p/ benefícios, premiações, etc.
// props: value = [{...}] · onChange(novaLista) · subcampos = [{key,label,type?,placeholder?}]
//   type: 'texto' (default) | 'number' | 'textarea'
export default function ItensBuilder({ value = [], onChange, subcampos = [], addLabel = 'Adicionar item' }) {
  const itens = Array.isArray(value) ? value : []
  const upd = (i, key, v) => onChange(itens.map((it, idx) => (idx === i ? { ...it, [key]: v } : it)))
  const add = () => onChange([...itens, {}])
  const del = (i) => onChange(itens.filter((_, idx) => idx !== i))
  const move = (i, d) => {
    const j = i + d
    if (j < 0 || j >= itens.length) return
    const arr = [...itens];[arr[i], arr[j]] = [arr[j], arr[i]]; onChange(arr)
  }

  return (
    <div className="space-y-2">
      {itens.length === 0 && <p className="text-xs text-gray-400 italic">Nenhum item ainda.</p>}
      {itens.map((it, i) => (
        <div key={i} className="border border-gray-200 rounded-xl p-3 space-y-2 bg-gray-50/60">
          <div className="grid grid-cols-2 gap-2">
            {subcampos.map((sc) => (
              <div key={sc.key} className={sc.type === 'textarea' ? 'col-span-2' : ''}>
                <label className="text-[11px] text-gray-500">{sc.label}</label>
                {sc.type === 'textarea' ? (
                  <textarea value={it[sc.key] ?? ''} rows={2} placeholder={sc.placeholder || ''}
                    onChange={(e) => upd(i, sc.key, e.target.value)}
                    className="w-full border border-gray-200 rounded-lg px-2 py-1.5 text-sm" />
                ) : (
                  <input type={sc.type === 'number' ? 'number' : 'text'} value={it[sc.key] ?? ''} placeholder={sc.placeholder || ''}
                    onChange={(e) => upd(i, sc.key, sc.type === 'number' ? (e.target.value === '' ? '' : Number(e.target.value)) : e.target.value)}
                    className="w-full border border-gray-200 rounded-lg px-2 py-1.5 text-sm" />
                )}
              </div>
            ))}
          </div>
          <div className="flex items-center justify-end gap-1">
            <button type="button" onClick={() => move(i, -1)} className="text-gray-400 hover:text-gray-700 px-1 text-xs">↑</button>
            <button type="button" onClick={() => move(i, 1)} className="text-gray-400 hover:text-gray-700 px-1 text-xs">↓</button>
            <button type="button" onClick={() => del(i)} className="text-gray-400 hover:text-red-600 p-1"><Trash2 size={15} /></button>
          </div>
        </div>
      ))}
      <button type="button" onClick={add} className="flex items-center gap-1.5 text-sm text-accent-600 font-semibold hover:text-accent-700">
        <Plus size={15} /> {addLabel}
      </button>
    </div>
  )
}
